import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
  ["1. Introduction", ["RoboSpark PrP Pvt Ltd (“we”, “us”, or “our”) operates the Robo-X mobile application. This Privacy Policy explains how we collect, use, store, and protect your information when you use the Robo-X app."]],
  ["2. Information We Collect", null, [
    "Account information such as name, email address, and phone number when you register.",
    "Payment-related information processed through Razorpay or Google Play Billing. We do not store full card or bank details on our servers.",
    "Usage data, device information, and app activity to improve performance and security.",
    "Trading preferences and activity within the app."]],
  ["3. How We Use Your Information", null, [
    "To provide and maintain the Robo-X app and subscription services.",
    "To process payments for the monthly subscription.",
    "To communicate with you regarding your account, updates, or support.",
    "To improve app functionality, security, and user experience.",
    "To comply with applicable laws and regulations."]],
  ["4. Data Sharing", ["We do not sell your personal data. We may share information with:"], [
    "Payment processors (Razorpay and Google Play).",
    "Service providers who assist in operating the app.",
    "Regulatory or legal authorities when required by law."]],
  ["5. Data Security", ["We implement reasonable technical and organizational measures to protect your information. However, no method of transmission over the internet is completely secure."]],
  ["6. Your Rights", ["You may request access to, correction of, or deletion of your personal data by contacting us. We will respond to such requests in accordance with applicable laws."]],
];

export default function PrivacyPolicy() {
  return <LegalPage prefix="privacy" title="Robo-X Privacy Policy" updated="3 November 2026" sections={SECTIONS}
    contactIntro="If you have any questions about this Privacy Policy, please contact us at:"
    closing="By using the Robo-X app, you agree to the collection and use of information in accordance with this Privacy Policy." />;
}
